import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-risk-impact',
    templateUrl: './risk-impact.component.html',
    styleUrls: ['./risk-impact.component.css']
})
export class RiskImpactComponent implements OnInit {
    @Input() public impactHeaderText: string;
    @Input() public impactTypeText: string;
    @Input() public customerImpactText: string;
    @Input() public regulatoryImpactText: string;
    @Input() public strategicImpactText: string;

    constructor() { }

    ngOnInit() {
    }

}
